import axios from 'axios';
import { ONE, ZERO } from '@/constants/common';

import { PluginMock } from '@/components/admin/plugins/pluginMock';
import md5 from 'crypto-js/md5';
/**
 * Plugins may refuse to register when they consider the minerva version incompatible, so the
 * version has to be passed in by the caller - it cannot be read from the store here without
 * introducing a dependency cycle (plugins.thunks imports this module).
 */
export const validatePluginContent = async (
  url: string,
  minervaVersion: string,
): Promise<{ name: string; version: string; newHash: string }> => {
  try {
    const response = await axios.get(url);

    let pluginScript = response.data;

    const hash = md5(pluginScript).toString();

    pluginScript += `//# sourceURL=${url}`;

    PluginMock.init(minervaVersion);
    /* eslint-disable no-new-func */
    const loadPlugin = new Function(pluginScript);

    await loadPlugin();

    const pluginData = PluginMock.getPluginData(url);
    if (!pluginData) {
      throw new Error(
        'The plugin was loaded but it did not register itself. It might be incompatible with ' +
          `this minerva version (${minervaVersion}). Check the browser console for details.`,
      );
    }

    return {
      ...pluginData,
      newHash: hash,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to validate plugin content', error);
    throw new Error(error instanceof Error ? error.message : 'Failed to validate plugin content');
  }
};

export const getIdFromIdentifiersOrgUri = (uri: string): string | null => {
  const lastIndex = Math.max(uri.lastIndexOf('/'), uri.lastIndexOf(':'));
  return lastIndex > ZERO ? uri.substring(lastIndex + ONE) : null;
};
